   // JavaScript to handle the "Edit" button click
   document.addEventListener("DOMContentLoaded", function () {

    document.getElementById('edit-profile-photo')?.addEventListener('click', function() {
        document.getElementById('user-profile-input').click();
    });

    document.getElementById('user-profile-input')?.addEventListener('change', function(event) {
        const file = event.target.files[0];
        const errorMessage = document.getElementById('file-size-error');
        if (errorMessage) {
            errorMessage.remove();
        }
        if (file && file.type.startsWith('image/')) {
            if (file.size > 10 * 1024 * 1024) {
                const errorMessage = document.createElement('p');
                errorMessage.id = 'file-size-error';
                errorMessage.textContent = 'The file size exceeds 10MB!';
                errorMessage.style.color = '#fff'; 
                errorMessage.style.fontSize = '10px'
                document.querySelector('.user-info_edit-profile-contailer').appendChild(errorMessage);
                return; 
            }
            const reader = new FileReader();
            reader.onload = function(e) {
                // Show a preview of the selected image before upload
                document.getElementById('profile-image').src = e.target.result;
    
                // Get the customer ID from the hidden input
                const customerId = document.getElementById('customer-id').value;
    
                // Prepare the form data to send the file and customer ID to the server
                const formData = new FormData();
                formData.append('file', file);
                formData.append('customer_id', customerId);  // Add the customer ID
                // formData.append('type', 'update-profile-metafield');  // Add type
    
                // Send the file and customer ID to the backend using Fetch API
                // fetch(`http://localhost:3000/api/update-profile-metafield?customer_id=${customerId}`, { 
                fetch(`https://nodejs.animeal.in/api/update-customer-profile?customer_id=${customerId}`, { 
                    method: 'POST',
                    body: formData,
                })
                .then(response => response.json())
                .then(data => {
                    if (data.message === 'Profile image updated successfully') {
                        // Optionally, update the profile image URL if the server returns a new URL
                        // document.getElementById('profile-image').src = data.file.path; // Adjust based on your backend response
                    } else {
                        // alert('Error uploading file: ' + data.error);
                    }
                })
                .catch(error => {
                    // console.error('Error:', error);
                    // alert('Failed to upload image.');
                });
            };
            reader.readAsDataURL(file);
        } else {
            alert('Please select a valid image file.');
        }
    });
    
    
    // document.getElementById('user-profile-input').addEventListener('change', function(event) {
    //     const file = event.target.files[0];
    //     if (file && file.type.startsWith('image/')) {
    //         const reader = new FileReader();
    //         reader.onload = function(e) {
    //         document.getElementById('profile-image').src = e.target.result;
    //         };
    //         reader.readAsDataURL(file);
    //     } else {
    //         alert('Please select a valid image file.');
    //     }
    // });
      





    // Get the Edit button and the update form
    var editButton = document.getElementById('edit_user');
    var updateForm = document.getElementById('name_mob_update');
    let cancleBtn = document.getElementById('name_mob_update-cancel-btn');

    // Listen for click on Edit button
    editButton?.addEventListener('click', function () {
        // Show the update form
        updateForm.style.display = 'block';

        // Set the opacity of the Edit button to 0
        editButton.style.opacity = '0';

        // Optionally disable the Edit button to prevent repeated clicks
        editButton.style.pointerEvents = 'none';
    });
    cancleBtn?.addEventListener('click', function(){
         // Show the update form
         updateForm.style.display = 'none';

         // Set the opacity of the Edit button to 0
         editButton.style.opacity = '0.6';
 
         // Optionally disable the Edit button to prevent repeated clicks
         editButton.style.pointerEvents = 'auto';
    })
});


// // user-info below content





// let notiBtn = document.querySelectorAll('.noti_button');
// let notiBackground = document.querySelectorAll('.toggle_main');

// // Function to handle the toggle logic
// function handleToggleClass(trans, index, toggleClass, bgChangeClass) {
//     if (trans.classList.contains(toggleClass)) {
//         trans.classList.remove(toggleClass);
//         notiBackground[index].classList.remove(bgChangeClass);
//     } else {
//         trans.classList.add(toggleClass);
//         notiBackground[index].classList.add(bgChangeClass);
//     }
// }

// // Determine the toggle class based on screen width
// function getToggleClass() {
//     if (window.innerWidth <= 400) {
//         return 'toggle3'; // For small screens
//     } else if (window.innerWidth <= 520) {
//         return 'toggle2'; // For medium screens
//     } else if (window.innerWidth <= 768) {
//         return 'toggle';  // For larger screens
//     } else if (window.innerWidth >= 768) {
//         return 'toggle4';  // For larger screens
//     }
// }

// // Add event listeners
// notiBtn.forEach((trans, index) => {
//     console.log("for each run");

//     trans.addEventListener('click', () => {
//         // Get the appropriate toggle class based on screen width
//         const toggleClass = getToggleClass();
//         handleToggleClass(trans, index, toggleClass, 'bg_change');
//     });
// });

// // You can also add a resize event listener to adjust behavior dynamically on window resize:
// window.addEventListener('resize', () => {
//     // Re-attach event listeners based on the new screen width
//     notiBtn.forEach((trans, index) => {
//         // Get the appropriate toggle class based on the new screen width
//         const toggleClass = getToggleClass();
//         trans.removeEventListener('click', () => {
//             handleToggleClass(trans, index, toggleClass, 'bg_change');
//         });
//         trans.addEventListener('click', () => {
//             handleToggleClass(trans, index, toggleClass, 'bg_change');
//         });
//     });
// });